// import { useState } from "react";
// import Button from "../ResuableCompoment/Button";
// import useApi from "../CustomHooks/useApi";
// import bingopayLogo from "../Assets/Images/bingopayLogo.png"
// import retail from "../Assets/Images/retail (1).jpg";
// import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router-dom";

// const ForgotPassword = () => {

//     const location = useLocation();
//     const passwordscreen = location.state?.passwordscreen || false;
//     const mpinscreen = location.state?.mpinscreen || false;

//     console.log("mpinscreeenn", mpinscreen);
//     const mobileNumber = location.state?.mobileNumber || null;

//     const skipOtp = location.state?.skipOtp || false;

//     // const [otpscreen, setOtpScreen] = useState(true);
//     const [otpscreen, setOtpScreen] = useState(!skipOtp);

//     const [otp, setOtp] = useState("");
//     const [mpin, setMpin] = useState("");
//     const [confirmMpin, setConfirmMpin] = useState("");
//     const [newPassword, setNewPassword] = useState("");
//     const [confirmPassword, setConfirmPassword] = useState("");
//     const [errorMessage, setErrorMessage] = useState("");
//     const navigate = useNavigate();

//     const verifyOtpApi = useApi("/staff/onboard/verify/indus/otp", "POST", false);
//     const resetPasswordApi = useApi("/staff/onboard/forget/password", "POST", false);

//     const handleOtpSubmit = async (e) => {
//         e.preventDefault();
//         if (otp.length !== 6) {
//             setErrorMessage("Enter a valid 6-digit OTP");
//             return;
//         }

//         const response = await verifyOtpApi.callApi(null, `?mobileNumber=${mobileNumber}&otp=${otp}`);
//         if (response.otp_status === "FAILED") {
//             setOtpScreen(true);
//             setErrorMessage("Invalid OTP");
//         } else if (response.otp_status === "VERIFIED") {
//             setOtpScreen(false);
//         }
//     };

//     const handleMpinSubmit = async (e) => {
//         e.preventDefault();
//         if (mpinscreen || (!mpinscreen && !passwordscreen)) {
//             if (mpin.length !== 6 || /(\d)\1{3}/.test(mpin)) {
//                 setErrorMessage("MPIN should be 6 digits and should not contain the same digit 4 times in a row");
//                 return;
//             }
//             if (mpin !== confirmMpin) {
//                 setErrorMessage("MPINs do not match");
//                 return;
//             }
//         }

//         if (passwordscreen || (!mpinscreen && !passwordscreen)) {
//             if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,20}$/.test(newPassword)) {
//                 setErrorMessage("Password must be 6-20 characters, include letters, numbers, and special characters, and have no spaces");
//                 return;
//             }
//             if (newPassword !== confirmPassword) {
//                 setErrorMessage("Passwords do not match");
//                 return;
//             }
//         }
//         const requestBody = {
//             mobile_number: mobileNumber,
//             password: (!mpinscreen || (!mpinscreen && !passwordscreen)) ? newPassword : null,
//             confirm_password: (!mpinscreen || (!mpinscreen && !passwordscreen)) ? confirmPassword : null,
//             otp,
//             mpin: (!passwordscreen || (!mpinscreen && !passwordscreen)) ? mpin : null,
//             confirm_mpin: (!passwordscreen || (!mpinscreen && !passwordscreen)) ? confirmMpin : null,
//         };

//         const response = await resetPasswordApi.callApi(requestBody);
//         if (response.status === "VERIFIED") {
//             setErrorMessage(response.message);
//             setTimeout(() => {
//                 navigate("/");
//             }, 1000);
//         } else {
//             setErrorMessage("Failed to reset password");
//         }
//     };

//     return (
//         <div className="relative h-screen w-full flex items-center justify-center">
//             <img src={retail} alt="Background" className="absolute top-0 left-0 w-full h-full object-cover" />
//             <div className="relative w-4/5 md:w-1/3 bg-white bg-opacity-75 rounded-xl p-8 shadow-xl max-w-lg">
//                 <div className="flex justify-center mb-4">
//                     <img src={bingopayLogo} alt="bingopay Logo" className="h-12" />
//                 </div>
//                 <div className="overflow-hidden whitespace-nowrap relative w-full">
//                     <strong>
//                         <p
//                             className="text-sm text-black-700 mb-6 text-center leading-relaxed inline-block"
//                             style={{
//                                 animation: "marquee 8s linear infinite",
//                             }}
//                         >
//                             Today is a new day. It's your day. Sign in to start managing your business.
//                         </p>
//                     </strong>
//                 </div>
//                 {otpscreen ? (
//                     <form onSubmit={handleOtpSubmit}>
//                         <h2 className="text-xl font-semibold mb-4 text-center">Enter OTP</h2>
//                         <div className="mb-4">
//                             <label className="block text-sm font-medium mb-2">6-digit OTP</label>
//                             <input
//                                 type="text"
//                                 value={otp}
//                                 onChange={(e) => {
//                                             const value = e.target.value;
//                                             if (/^\d*$/.test(value)) {
//                                                 setOtp(value);
//                                             }
//                                             setErrorMessage("");
//                                         }}
//                                 maxLength={6}
//                                 inputMode="numeric"
//                                 pattern="[0-9]*"
//                                 className="w-full px-4 py-2 border border-gray-300 rounded-lg"
//                                 placeholder="Enter OTP"
//                             />
//                         </div>
//                         {errorMessage && <p className="text-red-500 mt-2">{errorMessage}</p>}
//                         <Button label="Verify OTP" type="submit" variant="primary" fullWidth />
//                     </form>
//                 ) : (
//                     <form onSubmit={handleMpinSubmit}>
//                         <h2 className="text-xl font-semibold mb-4">
//                             {passwordscreen && !mpinscreen
//                                 ? "Set Password"
//                                 : mpinscreen && !passwordscreen
//                                     ? "Set MPIN"
//                                     : "Set MPIN & Password"}
//                         </h2>

//                         {(mpinscreen || (!mpinscreen && !passwordscreen)) && (
//                             <>
//                                 <div className="mb-4">
//                                     <label className="block text-sm font-medium mb-2">MPIN (6-digit)</label>
//                                     <input
//                                         type="text"
//                                         inputMode="numeric"
//                                         autoComplete="new-password"
//                                         value={mpin}
//                                         onChange={(e) => {
//                                             const value = e.target.value;
//                                             if (/^\d*$/.test(value)) {
//                                                 setMpin(value);
//                                             }
//                                             setErrorMessage("");
//                                         }}
//                                         maxLength={6}
//                                         className="w-full px-4 py-2 border border-gray-300 rounded-lg"
//                                         placeholder="Enter MPIN"
//                                     />
//                                 </div>

//                                 <div className="mb-4">
//                                     <label className="block text-sm font-medium mb-2">Confirm MPIN</label>
//                                     <input
//                                         type="password"
//                                         inputMode="numeric"
//                                         autoComplete="new-password"
//                                         value={confirmMpin}
//                                         onChange={(e) => {
//                                             const value = e.target.value;
//                                             if (/^\d*$/.test(value)) {
//                                                 setConfirmMpin(value);
//                                             }
//                                             setErrorMessage("");
//                                         }}
//                                         maxLength={6}
//                                         className="w-full px-4 py-2 border border-gray-300 rounded-lg"
//                                         placeholder="Confirm MPIN"
//                                     />
//                                 </div>
//                             </>

//                         )}

//                         {(passwordscreen || (!mpinscreen && !passwordscreen)) && (
//                             <>
//                                 <div className="mb-4">
//                                     <label className="block text-sm font-medium mb-2">New Password</label>
//                                     <input
//                                         type="password"
//                                         value={newPassword}
//                                         onChange={(e) => {
//                                             setNewPassword(e.target.value);
//                                             setErrorMessage("");
//                                         }}
//                                         className="w-full px-4 py-2 border border-gray-300 rounded-lg"
//                                         placeholder="Enter New Password"
//                                     />
//                                 </div>
//                                 <div className="mb-4">
//                                     <label className="block text-sm font-medium mb-2">Confirm Password</label>
//                                     <input
//                                         type="password"
//                                         value={confirmPassword}
//                                         onChange={(e) => {
//                                             setConfirmPassword(e.target.value);
//                                             setErrorMessage("");
//                                         }}
//                                         className="w-full px-4 py-2 border border-gray-300 rounded-lg"
//                                         placeholder="Confirm Password"
//                                     />
//                                 </div>
//                             </>
//                         )}

//                         {errorMessage && <p className="text-red-500 mt-2">{errorMessage}</p>}

//                         <Button
//                             label={
//                                 passwordscreen && !mpinscreen
//                                     ? "Set Password"
//                                     : mpinscreen && !passwordscreen
//                                         ? "Set MPIN"
//                                         : "Set MPIN & Password"
//                             }
//                             type="submit"
//                             variant="primary"
//                             fullWidth
//                         />
//                     </form>

//                 )}
//             </div>
//             <style>
//                 {`
//           @keyframes marquee {
//             0% { transform: translateX(100%); }
//             100% { transform: translateX(-100%); }
//           }
//         `}
//             </style>
//         </div>

//     );
// };

// export default ForgotPassword;







import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useApi from "../CustomHooks/useApi";
import bingopayLogo from "../Assets/Images/logoBingo.png";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const passwordscreen = location.state?.passwordscreen || false;
  const mpinscreen = location.state?.mpinscreen || false;
  const mobileNumber = location.state?.mobileNumber || null;
  const skipOtp = location.state?.skipOtp || false;

  const [otpscreen, setOtpScreen] = useState(false);
  const [otp, setOtp] = useState("");
  const [mpin, setMpin] = useState("");
  const [confirmMpin, setConfirmMpin] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [step, setStep] = useState(() => {
    if (passwordscreen && mpinscreen) return "PASSWORD";
    if (passwordscreen) return "PASSWORD";
    if (mpinscreen) return "MPIN";
    return "PASSWORD";
  });
  const [pendingPayload, setPendingPayload] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [otpSentTo, setOtpSentTo] = useState("");

  const resetPasswordApi = useApi("/staff/onboard/forget/password", "POST", false);

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    if (otp.length !== 6) {
      setErrorMessage("Enter a valid 6-digit OTP");
      return;
    }

    setIsLoading(true);
    try {
      const res = await resetPasswordApi.callApi({ ...pendingPayload, otp });
      if (res?.status === "VERIFIED" || res?.status === "SUCCESS") {
        setOtpScreen(false);
        setPendingPayload(null);
        setOtpSentTo("");
        if (pendingPayload?.password !== undefined) {
          setStep("MPIN");
        } else {
          setTimeout(() => navigate("/"), 1000);
        }
        setErrorMessage("");
      } else {
        setErrorMessage(res?.message || "Invalid OTP. Please try again.");
      }
    } catch (err) {
      setErrorMessage(err?.response?.data?.message || "OTP verification failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    if (step === "PASSWORD") {
      if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,20}$/.test(newPassword)) {
        setErrorMessage("Password must be 6–20 characters with letters, numbers & special characters");
        return;
      }
      if (newPassword !== confirmPassword) {
        setErrorMessage("Passwords do not match");
        return;
      }
    }

    if (step === "MPIN") {
      if (!/^\d{6}$/.test(mpin)) {
        setErrorMessage("MPIN must be exactly 6 digits");
        return;
      }
      if (mpin !== confirmMpin) {
        setErrorMessage("MPIN and Confirm MPIN do not match");
        return;
      }
    }

    const body = step === "PASSWORD"
      ? { mobile_number : mobileNumber, password: newPassword, confirm_password : confirmPassword }
      : { mobile_number : mobileNumber, mpin, confirm_mpin : confirmMpin };

    setIsLoading(true);
    try {
      const res = await resetPasswordApi.callApi(body);
      if (res?.status === "VERIFIED" || res?.status === "SUCCESS") {
        if (step === "PASSWORD") {
          setStep("MPIN");
          setErrorMessage("");
        } else {
          setTimeout(() => navigate("/"), 1000);
        }
      } else {
        setErrorMessage(res?.message || "Failed to update credentials");
      }
    } catch (err) {
      if (err?.response?.status === 400 && err?.response?.data?.error_code === "OTP_REQUIRED") {
        setPendingPayload(body);
        setOtpSentTo(err?.response?.data?.action_params?.sentTo || "");
        setOtp("");
        setOtpScreen(true);
      } else {
        setErrorMessage(err?.response?.data?.message || "Failed to update credentials");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex bg-[#0B0F1A] relative overflow-hidden">
      {/* Ambient gradients */}
      <div className="absolute inset-0">
        <div className="absolute top-[-20%] left-[-10%] w-[500px] h-[500px] bg-indigo-600/20 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-20%] right-[-10%] w-[500px] h-[500px] bg-cyan-500/20 rounded-full blur-[120px]" />
      </div>

      <div className="w-full flex items-center justify-center relative z-10 px-6">
        <div className="w-full max-w-md bg-white/95 backdrop-blur-xl rounded-2xl shadow-[0_30px_80px_-20px_rgba(0,0,0,0.6)] p-8">
          <div className="flex flex-col items-center mb-6">
            <img src={bingopayLogo} alt="BingoPay" className="h-12 mb-3" />
            <h2 className="text-xl font-semibold text-slate-900">
              Secure Account Recovery
            </h2>
            <p className="text-sm text-slate-500 text-center mt-1">
              Verify your identity to continue
            </p>
          </div>

          {otpscreen ? (
            <form onSubmit={handleOtpSubmit} className="space-y-6">
              {otpSentTo && (
                <p className="text-sm text-slate-500 text-center">
                  OTP sent to <span className="font-semibold text-slate-800">{otpSentTo}</span>
                </p>
              )}
              <div className="relative">
                <input
                  value={otp}
                  onChange={(e) => {
                    if (/^\d*$/.test(e.target.value)) setOtp(e.target.value);
                    setErrorMessage("");
                  }}
                  maxLength={6}
                  className="peer w-full px-4 pt-5 pb-2 border border-slate-300 rounded-xl focus:border-indigo-600 focus:outline-none"
                  placeholder=" "
                />
                <label className="absolute left-4 top-3 text-sm text-slate-500 peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-focus:top-3 peer-focus:text-sm peer-focus:text-indigo-600 transition-all">
                  Enter OTP
                </label>
              </div>

              {errorMessage && (
                <p className="text-sm text-red-600">{errorMessage}</p>
              )}

              <button
                type="submit"
                disabled={isLoading}
                className="w-full py-3 rounded-xl bg-gradient-to-r from-indigo-600 to-cyan-500 text-white font-semibold shadow-lg hover:shadow-xl transition disabled:opacity-70 disabled:cursor-not-allowed"
              >
                {isLoading ? "Verifying..." : "Verify OTP"}
              </button>
            </form>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* {passwordscreen && (
                <>
                  <div className="relative">
                    <input
                      type="password"
                      value={newPassword}
                      onChange={(e) => {
                        setNewPassword(e.target.value);
                        setErrorMessage("");
                      }}
                      className="peer w-full px-4 pt-5 pb-2 border border-slate-300 rounded-xl focus:border-indigo-600 focus:outline-none"
                      placeholder=" "
                    />
                    <label className="absolute left-4 top-3 text-sm text-slate-500 peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-focus:top-3 peer-focus:text-sm peer-focus:text-indigo-600 transition-all">
                      New Password
                    </label>
                  </div>

                  <div className="relative">
                    <input
                      type="password"
                      value={confirmPassword}
                      onChange={(e) => {
                        setConfirmPassword(e.target.value);
                        setErrorMessage("");
                      }}
                      className="peer w-full px-4 pt-5 pb-2 border border-slate-300 rounded-xl focus:border-indigo-600 focus:outline-none"
                      placeholder=" "
                    />
                    <label className="absolute left-4 top-3 text-sm text-slate-500 peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-focus:top-3 peer-focus:text-sm peer-focus:text-indigo-600 transition-all">
                      Confirm Password
                    </label>
                  </div>
                </>
              )} */}

              {step === "PASSWORD" && (
                <>
                  {/* New Password */}
                  <div className="relative">
                    <input
                      type="password"
                      value={newPassword}
                      onChange={(e) => {
                        setNewPassword(e.target.value);
                        setErrorMessage("");
                      }}
                      className="peer w-full px-4 pt-5 pb-2 border border-slate-300 rounded-xl
                   focus:border-indigo-600 focus:outline-none"
                      placeholder=" "
                    />
                    <label className="absolute left-4 top-3 text-sm text-slate-500">
                      New Password
                    </label>
                  </div>

                  {/* Confirm Password */}
                  <div className="relative">
                    <input
                      type="password"
                      value={confirmPassword}
                      onChange={(e) => {
                        setConfirmPassword(e.target.value);
                        setErrorMessage("");
                      }}
                      className="peer w-full px-4 pt-5 pb-2 border border-slate-300 rounded-xl
                   focus:border-indigo-600 focus:outline-none"
                      placeholder=" "
                    />
                    <label className="absolute left-4 top-3 text-sm text-slate-500">
                      Confirm Password
                    </label>
                  </div>
                </>
              )}

              {/* {mpinscreen && (
                <>
                  <div className="relative">
                    <input
                      value={mpin}
                      onChange={(e) => {
                        if (/^\d*$/.test(e.target.value)) setMpin(e.target.value);
                        setErrorMessage("");
                      }}
                      maxLength={6}
                      className="peer w-full px-4 pt-5 pb-2 border border-slate-300 rounded-xl focus:border-indigo-600 focus:outline-none"
                      placeholder=" "
                    />
                    <label className="absolute left-4 top-3 text-sm text-slate-500 peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-focus:top-3 peer-focus:text-sm peer-focus:text-indigo-600 transition-all">
                      MPIN
                    </label>
                  </div>

                  <div className="relative">
                    <input
                      value={confirmMpin}
                      onChange={(e) => {
                        if (/^\d*$/.test(e.target.value))
                          setConfirmMpin(e.target.value);
                        setErrorMessage("");
                      }}
                      maxLength={6}
                      className="peer w-full px-4 pt-5 pb-2 border border-slate-300 rounded-xl focus:border-indigo-600 focus:outline-none"
                      placeholder=" "
                    />
                    <label className="absolute left-4 top-3 text-sm text-slate-500 peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-focus:top-3 peer-focus:text-sm peer-focus:text-indigo-600 transition-all">
                      Confirm MPIN
                    </label>
                  </div>
                </>
              )} */}

              {step === "MPIN" && (
                <>
                  <div className="relative">
                    {/* <input
                      value={mpin}
                      maxLength={6}
                      onChange={(e) => {
                        if (/^\d*$/.test(e.target.value)) setMpin(e.target.value);
                        setErrorMessage("");
                      }}
                      className="peer w-full px-4 pt-5 pb-2 border border-slate-300 rounded-xl
                   focus:border-indigo-600 focus:outline-none"
                      placeholder=" "
                    /> */}
                    <input
                      value={mpin}
                      inputMode="numeric"
                      maxLength={6}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ""); // ✅ digits only
                        if (value.length <= 6) {
                          setMpin(value);
                        }
                        setErrorMessage("");
                      }}
                      className="peer w-full px-4 pt-5 pb-2 border border-slate-300 rounded-xl
             focus:border-indigo-600 focus:outline-none"
                      placeholder=" "
                    />
                    <label className="absolute left-4 top-3 text-sm text-slate-500">
                      MPIN
                    </label>
                  </div>

                  <div className="relative">
                    {/* <input
                      value={confirmMpin}
                      maxLength={6}
                      onChange={(e) => {
                        if (/^\d*$/.test(e.target.value)) setConfirmMpin(e.target.value);
                        setErrorMessage("");
                      }}
                      className="peer w-full px-4 pt-5 pb-2 border border-slate-300 rounded-xl
                   focus:border-indigo-600 focus:outline-none"
                      placeholder=" "
                    /> */}
                    <input
                      value={confirmMpin}
                      inputMode="numeric"
                      maxLength={6}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ""); // ✅ digits only
                        if (value.length <= 6) {
                          setConfirmMpin(value);
                        }
                        setErrorMessage("");
                      }}
                      className="peer w-full px-4 pt-5 pb-2 border border-slate-300 rounded-xl
             focus:border-indigo-600 focus:outline-none"
                      placeholder=" "
                    />
                    <label className="absolute left-4 top-3 text-sm text-slate-500">
                      Confirm MPIN
                    </label>
                  </div>
                </>
              )}

              {errorMessage && (
                <p className="text-sm text-red-600">{errorMessage}</p>
              )}

              {/* <button
                type="submit"
                className="w-full py-3 rounded-xl bg-gradient-to-r from-indigo-600 to-cyan-500 text-white font-semibold shadow-lg hover:shadow-xl transition"
              >
                Update Credentials
              </button> */}
              {/* <button
                type="submit"
                className="w-full py-3 rounded-xl bg-gradient-to-r from-indigo-600 to-cyan-500 text-white font-semibold shadow-lg hover:shadow-xl transition"
              >
                {step === "PASSWORD" ? "Set Password" : "Set MPIN"}
              </button> */}
              <button
                type="submit"
                disabled={isLoading || (step === "MPIN" && mpin.length !== 6)}
                className={`w-full py-3 rounded-xl text-white font-semibold shadow-lg transition
    ${isLoading || (step === "MPIN" && mpin.length !== 6)
                    ? "bg-slate-400 cursor-not-allowed"
                    : "bg-gradient-to-r from-indigo-600 to-cyan-500 hover:shadow-xl"
                  }
  `}
              >
                {isLoading ? "Processing..." : step === "PASSWORD" ? "Set Password" : "Set MPIN"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
